import useSWR from 'swr'
import fetcher from '../utils/fetcher'

const useDealerCountries = (language) => {
    const url = `https://extranet.greentec.eu/api/dealers/countries?language=${language}`

    const {data, error} = useSWR(url, fetcher)

    return {
        dealerCountries: data,
        dealerCountriesLoading: !error && !data,
        dealerCountriesError: error
    }
}

export default useDealerCountries